<div style="position:relative;" [hidden]="HideComponent">
  <div class="row-no-margin section-header-container">
    <div class="col-md-12 clear-padding">
      <span class="section-header">Orders</span>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill">
            <mat-label>Filter by:</mat-label>
            <mat-select id="orderSort" (selectionChange)="OrderSort_Change($event)" [(value)]="OrderSortValue">
              <mat-option value="orderdate">
                Most Recent
              </mat-option>
              <mat-option value="statusopen">
                Open Orders
              </mat-option>
              <mat-option value="followed">
                Followed Orders
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 clear-padding">
          <mat-form-field *ngIf="CurUser.IsTolomaticUser" appearance="fill">
            <mat-label>Distributor:</mat-label>
            <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist">
              <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
                {{dist.Company}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3 clear-padding" style="text-align:right; line-height:80px;">
          <a (click)="ViewFullDetails()" class="clickable blue">View full details</a>
        </div>
      </div>
    </div>
  </div>
  <div>
    <table style="width:100%;">
      <tr>
        <th></th>
        <th>Order Number</th>
        <th style="text-align:center;">Order Date</th>
        <th style="text-align:center;">Status</th>
        <th style="text-align:center;">PO Number</th>
        <th style="text-align:center;">Ship to name</th>
        <!--<th>Follow</th>-->
      </tr>
      <ng-container *ngFor="let order of OrderList">
        <tr>
          <td>
            <button mat-icon-button aria-label="expand row" (click)="(order.Expanded = !order.Expanded); LoadDetails(order); $event.stopPropagation()">
              <mat-icon *ngIf="!order.Expanded" class="blue-color">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="order.Expanded" class="blue-color">keyboard_arrow_up</mat-icon>
            </button>
          </td>
          <td>
            {{order.OrderNumber}}
          </td>
          <td style="text-align:center;">{{order.OrderDate | date:'M/d/y'}}</td>
          <td style="text-align:center;">{{order.Status}}</td>
          <td style="text-align:center;">{{order.PONumber}}</td>
          <td [matTooltip]="order.ShipToName">{{order.ShortShipTo}}</td>
          <!--<td style="text-align:center;"><app-toggle [initial]="order.Following" [idForControl]="order.OrderNumber" [trueText]="" [falseText]="" (changed)="FollowOrder($event,order.OrderNumber)"></app-toggle></td>-->
        </tr>
        <ng-container *ngIf="order.Expanded">
          <tr>
            <td colspan="7">
              <table class="sub-table" style="width:100%;">
                <tr>
                  <th style="text-align:center;">Line</th>
                  <th>Item</th>
                  <th>Description</th>
                  <th style="text-align:center;">QTY</th>
                  <th style="text-align:center;">List Price</th>
                  <th style="text-align:center;">Unit Price</th>
                  <th style="text-align:center;">Ext Price</th>
                  <th style="text-align:center;">Status</th>
                  <th style="text-align:center;">Due Date</th>
                  <th style="text-align:center;">(Est) Ship Date</th>
                  <th style="text-align:center;">Tracking</th>
                  <th style="text-align:center;">Follow</th>
                </tr>
                <ng-container *ngFor="let detail of order.OrderLines">
                  <tr>
                    <td style="text-align:center;">
                      {{detail.OrderLine}}
                    </td>
                    <td>
                      {{detail.Item}}
                    </td>
                    <td [matTooltip]="detail.Description">
                      {{detail.ShortDesc}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.QtyOrdered}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.ListPrice | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.Price | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.ExtPrice | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      <span class="clickable blue-color" (click)="ViewDetails(order,detail)">{{detail.PortalStatus}}</span>
                    </td>
                    <td style="text-align:center;">
                      {{detail.DueDate  | date:'M/d/y'}}
                    </td>
                    <td style="text-align:center;">
                      <ng-container *ngIf="detail.ShipDate == null && detail.EstShipDate != null && detail.EstShipDate.length > 0">
                        ({{detail.EstShipDate  | date:'M/d/y'}})
                      </ng-container>
                      <ng-container *ngIf="detail.ShipDate != null && (detail.EstShipDate == detail.ShipDate || detail.EstShipDate == null || detail.EstShipDate.length == 0)">
                        {{detail.ShipDate  | date:'M/d/y'}}
                      </ng-container>
                    </td>
                    <td style="text-align:center;">
                      <span [innerHtml]="detail.TrackingNumber"></span>

                    </td>
                    <td style="text-align:center;"><app-toggle [initial]="order.Followed" [idForControl]="detail.OrderDetailRowPointer" [trueText]="" [falseText]="" (changed)="FollowOrder($event,detail.OrderDetailRowPointer)"></app-toggle></td>
                  </tr>
                </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
      </ng-container>

    </table>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
<app-modal [hidden]="true"></app-modal>

